import { SystemCode } from '@/api'
import { startsWith } from 'lodash'

export function isStrContainHiraganaOrKanji(inputName: string): boolean {
  return isStrContainHiragana(inputName) || isStrContainKanji(inputName)
}

// 下記は汎用性が高い為、必要があれば別の場所に記述して全体で使用するようにしてもいいと思う
// 作ったが、判定的にいらないのでコメントアウト
// function isStrOnlyKataKana(str: string): boolean {
//   const regex: RegExp = /^[\p{scx=Katakana}|ｦ-ﾟ]+$/u
//   return regex.test(str)
// }
//
// function isStrOnlyNumber(str: string): boolean {
//   const regex: RegExp = /^[0-9０-９]+$/u
//   return regex.test(str)
// }
//
// function isStrOnlyAlpha(str: string): boolean {
//   const regex: RegExp = /^[a-zA-Zａ-ｚＡ-Ｚ]+$/u
//   return regex.test(str)
// }

function isStrContainHiragana(str: string): boolean {
  const regex: RegExp = /\p{scx=Hiragana}+/u
  return regex.test(str)
}

function isStrContainKanji(str: string): boolean {
  const regex: RegExp = /\p{scx=Han}+/u
  return regex.test(str)
}

export function isGroupUser(userType: SystemCode): boolean {
  return startsWith(userType.code, '8')
}
